import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e822d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-circle me-2" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "sticky"
}
const _hoisted_3 = { class: "d-flex justify-content-end mb-1" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary btn-sm dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("แก้ไข ")
], -1))
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-invoice-dollar me-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-signature me-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt me-2" }, null, -1))
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลโครงการ:")
], -1))
const _hoisted_16 = { class: "card mt-2 mb-3" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }),
  /*#__PURE__*/_createTextVNode("ชื่อโครงการ:")
], -1))
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins me-2" }),
  /*#__PURE__*/_createTextVNode("ปีงบประมาณ:")
], -1))
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle me-2" }),
  /*#__PURE__*/_createTextVNode("จังหวัด:")
], -1))
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-th-large me-2" }),
  /*#__PURE__*/_createTextVNode("ประเภทโครงการ:")
], -1))
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_32 = { class: "text-muted mb-0" }
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-invoice-dollar me-2" }),
  /*#__PURE__*/_createTextVNode("การจัดสรรงบประมาณ:")
], -1))
const _hoisted_35 = { class: "card mt-2 mb-3" }
const _hoisted_36 = { class: "card-body my-0 pb-0" }
const _hoisted_37 = { class: "table mb-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ประเภท"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จำนวนเงิน")
  ])
], -1))
const _hoisted_39 = { class: "text-muted text-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "รวมทั้งสิ้น", -1))
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-signature me-2" }),
  /*#__PURE__*/_createTextVNode("การอนุมัติโครงการ:")
], -1))
const _hoisted_44 = { class: "card mt-2 mb-3" }
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = {
  key: 0,
  class: "row"
}
const _hoisted_47 = { class: "col-auto d-flex justify-content-center align-items-center" }
const _hoisted_48 = { class: "photo text-center" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "col" }
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }),
  /*#__PURE__*/_createTextVNode("ผู้อนุมัติโครงการ:")
], -1))
const _hoisted_53 = { class: "text-muted" }
const _hoisted_54 = { class: "mb-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-certificate me-2" }),
  /*#__PURE__*/_createTextVNode("ตำแแหน่ง:")
], -1))
const _hoisted_56 = { class: "text-muted" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่อนุมัติโครงการ:")
], -1))
const _hoisted_58 = { class: "text-muted mb-0" }
const _hoisted_59 = {
  key: 1,
  class: "text-muted mb-0"
}
const _hoisted_60 = { class: "mb-3" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารของโครงการ:")
], -1))
const _hoisted_62 = { class: "list-group mt-2" }
const _hoisted_63 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_65 = ["href"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_67 = { class: "mb-3" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-images me-2 mb-2" }),
  /*#__PURE__*/_createTextVNode("รูปประกอบ:")
], -1))
const _hoisted_69 = {
  key: 0,
  class: "list-group"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-group-item text-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่มีข้อมูล ")
], -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["href"]
const _hoisted_73 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasComponent = _resolveComponent("BaseOffcanvasComponent")!
  const _component_ProjectModalComponent = _resolveComponent("ProjectModalComponent")!
  const _component_BudgetModalComponent = _resolveComponent("BudgetModalComponent")!
  const _component_ApprovementModalComponent = _resolveComponent("ApprovementModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseOffcanvasComponent, {
      ref: "projectOffcanvas",
      placement: "right"
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        _createTextVNode("รายละเอียดโครงการ ")
      ]),
      default: _withCtx(() => [
        (!_ctx.project?.isFinished)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("ul", _hoisted_6, [
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editClick('project')))
                      }, [
                        _hoisted_7,
                        _createTextVNode("ข้อมูลโครงการ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editClick('budget')))
                      }, [
                        _hoisted_8,
                        _createTextVNode("การจัดสรรงบประมาณ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editClick('approvement')))
                      }, [
                        _hoisted_9,
                        _createTextVNode("การอนุมัติโครงการ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                      }, [
                        _hoisted_10,
                        _createTextVNode("จัดการเอกสารแนบ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                      }, [
                        _hoisted_11,
                        _createTextVNode("จัดการรูปประกอบ ")
                      ])
                    ]),
                    _hoisted_12,
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
                      }, [
                        _hoisted_13,
                        _createTextVNode("ลบ ")
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.project?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.project?.fiscalYear.name.replace('ปีงบประมาณ ', '')), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.project?.province.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.project?.projecType.name), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_31,
                _withDirectives(_createElementVNode("p", _hoisted_32, null, 512), [
                  [_directive_dompurify_html, _ctx.project?.description ? _ctx.project?.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project?.projectBudgets, (budget, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(budget.shortName), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(Number(budget.amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_40,
                    _createElementVNode("td", _hoisted_41, _toDisplayString(Number(_ctx.project?.projectBudgets.reduce((total, m) => total + (m.amount ? m.amount : 0), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              (_ctx.project?.projectApprovement)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("img", {
                          class: "photo-image",
                          src: _ctx.photoPreview,
                          width: "60",
                          height: "70",
                          alt: "preview"
                        }, null, 8, _hoisted_49)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.project?.projectApprovement.ministerName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.project?.projectApprovement.ministerPosition), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_57,
                        _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.thaiDate(_ctx.project.projectApprovement.approvedDate)), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_59, "ยังไม่มีข้อมูลอนุมัติโครงการ กรุณาเพิ่มข้อมูลผ่านเมนู \"แก้ไขข้อมูลอนุมัติ\""))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("ul", _hoisted_62, [
            (_ctx.attachments?.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_63, [
                  _hoisted_64,
                  _createTextVNode("ไม่มีข้อมูล ")
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.attachments, (attachment, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "list-group-item text-truncate"
                  }, [
                    _createElementVNode("a", {
                      href: attachment.file,
                      target: "_blank"
                    }, [
                      _hoisted_66,
                      _createTextVNode(_toDisplayString(attachment.name), 1)
                    ], 8, _hoisted_65)
                  ]))
                }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createElementVNode("div", null, [
            (_ctx.images.length === 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_69, _hoisted_71))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    href: image.file,
                    "data-lightbox": "project-images"
                  }, [
                    _createElementVNode("img", {
                      src: image.file,
                      class: "image-content",
                      alt: `image-${index}`
                    }, null, 8, _hoisted_73)
                  ], 8, _hoisted_72))
                }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.projectId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_ProjectModalComponent, {
            ref: "projectModal",
            "project-id": _ctx.projectId,
            onValidated: _ctx.updateProject
          }, null, 8, ["project-id", "onValidated"]),
          _createVNode(_component_BudgetModalComponent, {
            ref: "budgetModal",
            "project-id": _ctx.projectId,
            onValidated: _ctx.updateBudgets
          }, null, 8, ["project-id", "onValidated"]),
          _createVNode(_component_ApprovementModalComponent, {
            ref: "approvementModal",
            "project-id": _ctx.projectId,
            onValidated: _ctx.updateApprovement
          }, null, 8, ["project-id", "onValidated"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}